/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserRegistrationState {
	isRegistered: boolean;
	userKey: string | null;
	registrationTimestamp: string | null;
}

const initialState: UserRegistrationState = {
	isRegistered: false,
	userKey: null,
	registrationTimestamp: null
};

const userRegistrationSlice = createSlice({
	name: 'userRegistration',
	initialState,
	reducers: {
		setUserRegistered: (state, action: PayloadAction<{ userKey: string; timestamp: string }>) => {
			state.isRegistered = true;
			state.userKey = action.payload.userKey;
			state.registrationTimestamp = action.payload.timestamp;
		},
		setUserDisconnected: (state) => {
			state.isRegistered = false;
			state.userKey = null;
			state.registrationTimestamp = null;
		}
	}
});

export const { setUserRegistered, setUserDisconnected } = userRegistrationSlice.actions;
export default userRegistrationSlice.reducer;
